// Zellen für berechnete Spalten der Lead-Listen (Agent 5B, Runde 5): Anzahl Anrufe, letzte Kommunikation, nächste Aufgabe, Ort …
// Die Werte kommen aus `useBerechneteWerte` (daten/listenAnsichtStore.ts). Noch nicht geladen -> leere Zelle, kein Wert -> „—“.
import type { ReactNode } from "react";
import type { MetaWert } from "../../daten/meta";
import { berlinDatum, dauerText, datumText, gueltig, relativ, tagText, zeitpunktLang } from "../../werkzeuge/zeit";

const ENUM_TEXT: Record<string, string> = {
  outbound: "Ausgehend",
  inbound: "Eingehend",
  answered: "Angenommen",
  "no-answer": "Nicht angenommen",
  busy: "Besetzt",
  failed: "Fehlgeschlagen",
  cancelled: "Abgebrochen",
  blocked: "Blockiert",
  "vm-left": "Mailbox besprochen",
  "vm-answer": "Mailbox",
};

/** Wörter im Schlüssel, bei denen eine relative Angabe („vor 3 Tagen“) mehr hilft als das Datum. */
function relativZeigen(key: string): boolean {
  return /^(last|first)_/.test(key);
}

export function berechneteZelle(key: string, typ: string, wert: unknown, meta: MetaWert): ReactNode {
  if (wert === undefined) return null; // wird noch geholt
  if (wert === null || wert === "") return <span className="leer-wert">—</span>;
  switch (typ) {
    case "zahl": {
      const n = Number(wert);
      return Number.isFinite(n) ? <span className="zelle-zahl">{n.toLocaleString("de-DE")}</span> : <span className="leer-wert">—</span>;
    }
    case "dauer": {
      const n = Number(wert);
      return Number.isFinite(n) ? <span>{dauerText(Math.round(n))}</span> : <span className="leer-wert">—</span>;
    }
    case "zeit": {
      const t = String(wert);
      if (!gueltig(t)) return <span>{t}</span>;
      if (relativZeigen(key)) return <span title={zeitpunktLang(t)}>{relativ(t)}</span>;
      if (key === "next_task_date") return <span title={zeitpunktLang(t)}>{tagText(berlinDatum(t))}</span>;
      return <span title={zeitpunktLang(t)}>{datumText(berlinDatum(t))}</span>;
    }
    case "datum":
      return <span>{datumText(String(wert))}</span>;
    case "nutzer": {
      const name = meta.nutzerName(String(wert));
      return <span title={name}>{name}</span>;
    }
    case "enum": {
      const t = ENUM_TEXT[String(wert)] ?? String(wert);
      return <span title={t}>{t}</span>;
    }
    default: {
      const t = Array.isArray(wert) ? wert.join(", ") : String(wert);
      return <span title={t}>{t}</span>;
    }
  }
}
